<template>
  <v-card>
    <v-toolbar
      flat
      color="success"
      dark
      dense
    >
      <v-toolbar-title>Lập báo cáo</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="mt-4">
      <v-row>
        <v-col
          cols="12"
          sm="auto"
        >
          <v-select
            v-model="typeSelected"
            :items="types"
            item-text="text"
            item-value="value"
            label="Loại báo cáo"
            class="require"
            return-object
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider/>
    <v-card-actions class="justify-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="success"
            class="mr-2"
            v-bind="attrs"
            v-on="on"
            :loading="spin"
          >
            <v-icon class="mr-2">mdi-cloud-download</v-icon>
            Xem báo cáo
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(type, index) in exportTypes"
            :key="index"
            @click="getReport(type)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ type.toUpperCase() }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn color="yellow">
        Làm mới
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import FileSevice from '@/services/File';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {}
    },
    data () {
      return {
        spin: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        params: {},
        types: [
          {value: 'co_so' , text: "Báo cáo Cơ sở sản xuất kinh doanh"}
        ],
        typeSelected: null,
        exportTypes: ['pdf', 'xls', 'xlsx', 'docx'],
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        if (this.showDialog) {
          this.dialog = true;
        }
      }
    },
    methods: {
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      getReport(type){
        const app = this;
        app.spin = true;
        axios.post(
          'api/v1/report', 
          {
            type: app.typeSelected.value,
            file_type: type,
            params: app.params
          },
          {responseType: 'arraybuffer'}
        )
          .then(function (response) {
            FileSevice.download(response.data, `co_so.${type}`);
            app.spin=false;
          }).catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>